import React, { Children } from "react";
import { Tabs as AntTabs } from "antd";

const Tabs = (props) => {
  const { config, onTabChange, activeTab, children } = props;
  const onChange = (key) => {
    console.log(key);
  };
  return <AntTabs items={config.map((tab) => ({ ...tab, key: tab.key }))} onChange={onTabChange} type="card" destroyInactiveTabPane={true} />;
};
export default Tabs;
